import '../styles/globals.scss';
import Header from '../components/common/header';
import { Auth0Provider } from '@auth0/nextjs-auth0';
import InitialValidations from '../components/initial-validations';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNotifications } from 'react-notifications-component';
import Modal from 'react-modal';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Provider } from '../components/store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
Modal.setAppElement('#__next');
function App({ Component, pageProps }) {
  const router = useRouter();
  useEffect(() => {
    const handleRouteChange = (url) => {
      if (typeof window !== undefined && !!window.gtag) {
        window.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
          page_path: url,
        });
      }
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return (
    <Auth0Provider>
      <QueryClientProvider client={queryClient}>
        <Provider>
          <ReactNotifications />
          <InitialValidations>
            <Header />
            <Component {...pageProps} />
          </InitialValidations>
        </Provider>
      </QueryClientProvider>
    </Auth0Provider>
  );
}

// Only uncomment this method if you have blocking data requirements for
// every single page in your application. This disables the ability to
// perform automatic static optimization, causing every page in your app to
// be server-side rendered.
//
// MyApp.getInitialProps = async (appContext) => {
//   // calls page's `getInitialProps` and fills `appProps.pageProps`
//   const appProps = await App.getInitialProps(appContext);
//
//   return { ...appProps }
// }

export default App;
